// extracted by mini-css-extract-plugin
export default {"spin":"spin__y0D4rU","buttonMore":"buttonMore__PDk5Pz","providers":"providers__RkjTR2"};